import React from 'react';
import Icon from '../../../components/AppIcon';

const RatingDistributionChart = ({ ratingDistribution }) => {
  const total = Object.values(ratingDistribution || {})?.reduce((sum, count) => sum + count, 0) || 1;

  const ratings = [5, 4, 3, 2, 1];

  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-gray-200 dark:border-slate-700 p-6">
      <div className="flex items-center gap-2 mb-6">
        <Icon name="BarChart3" size={20} className="text-emerald-600" />
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Rating Distribution</h3>
      </div>

      <div className="space-y-4">
        {ratings?.map((rating) => {
          const count = ratingDistribution?.[rating] || 0;
          const percentage = total > 0 ? (count / total) * 100 : 0;

          return (
            <div key={rating} className="flex items-center gap-3">
              <div className="flex items-center gap-1 w-16">
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300">{rating}</span>
                <Icon name="Star" size={14} className="text-yellow-500 fill-yellow-500" />
              </div>
              <div className="flex-1">
                <div className="h-6 bg-gray-100 dark:bg-slate-700 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-gradient-to-r from-emerald-500 to-emerald-600 transition-all duration-500"
                    style={{ width: `${percentage}%` }}
                  />
                </div>
              </div>
              <div className="flex items-center gap-2 w-24">
                <span className="text-sm font-medium text-gray-900 dark:text-white">{count}</span>
                <span className="text-xs text-gray-500 dark:text-gray-400">({percentage?.toFixed(0)}%)</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RatingDistributionChart;